import { Box } from "@mui/material";

import styled from "styled-components";

export const NameLink = styled(Box)`
    font-size: 14px;
    font-weight: 700;
    color: #1d1d1f;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;

    &:hover {
        color: #ed6c02;
        text-decoration: underline;
    }
`;

export const ChipRow = styled(Box)`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    max-width: 100%;
    min-width: 0;
`;

export const MiniIconChip = styled(Box)`
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #f2f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: background 150ms ease;

    &:hover {
        background: #e5e5ea;
    }

    img {
        width: 15px;
        height: 15px;
        object-fit: contain;
    }
`;

export const MiniCountBadge = styled(Box)`
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 15px;
    height: 15px;
    padding: 0 3px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #6e6e73;
    color: #ffffff;
    font-size: 9px;
    font-weight: 700;
    font-family: "Nunito", sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #ffffff;
`;

export const MiniWarningDot = styled(Box)`
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #d32f2f;
    border: 1.5px solid #ffffff;
`;

export const EmptyCellText = styled(Box)`
    font-size: 13px;
    color: #aeaeb2;
    font-family: "Nunito", sans-serif;
`;
